<template>
  <div>
    <!-- <template v-if="!loadingScreen"> -->
    <v-col cols="12">
      <router-link to="/orders" style="text-decoration: none" title="Back">
        <v-btn
          color="warning"
          fab
          small
          dark
          style="float: left; margin-left: 5px"
        >
          <v-icon class="fa fa-arrow-left"></v-icon>
        </v-btn>
      </router-link>
    </v-col>

    <v-row class="border">
      <v-col cols="2" class="border">
        <v-list dense>
          <!-- <v-btn @click="check">Check</v-btn> -->
          <v-subheader>ORDER NUMBER</v-subheader>
          <v-subheader
            ><v-select
              v-model="storeFilter"
              dense
              outlined
              multiple
              :items="storeList"
              chips
              label="Filter By Store"
              style="margin-top: 15px"
              @change="filterData"
            ></v-select
          ></v-subheader>
          <span style="font-size: 12px">(Total: {{ count }} order(s))</span>
          <v-list-item-group
            v-model="selectedOrder"
            color="primary"
            class="ordernum-scroll"
          >
            <template v-for="(value, text, i) in dataPreview">
              <v-list-item
                :key="i"
                :value="text"
                @click="chooseOrder(text)"
                v-if="value.selected"
              >
                <v-list-item-content style="text-align: left">
                  <v-list-item-title
                    style="font-size: 12px"
                    v-text="value.orderNumItems"
                    v-if="!value.orderNumItems.includes('ERR')"
                  ></v-list-item-title>
                  <v-list-item-title
                    style="font-size: 12px; color: red"
                    v-text="value.orderNumItems"
                    v-else
                  ></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list-item-group>
        </v-list>
      </v-col>

      <v-col cols="10" v-if="!loadingScreen">
        <v-subheader>PREVIEW PRODUCTION</v-subheader>
        <v-col cols="12" v-if="selectedOrder != undefined">
          <div style="text-align: left">
            <b>Order Number: </b> {{ selectedOrder }} - <b>ID: </b>
            {{ selectedOrderData.order_id }} - <b>Status: </b>
            {{ selectedOrderData.current_status }} -
            <b>Priority: </b>
            <template v-if="selectedOrderData.priority == 0"> Normal </template>
            <template
              v-else-if="selectedOrderData.priority == 1"
              style="color: orange"
            >
              High
            </template>
            <template v-else style="color: red"> Urgent </template>
          </div>

          <div
            v-for="(i, index) in selectedOrderData.items"
            :key="index"
            class="border"
          >
            <v-col class="12" style="font-size: 14px">
              <v-row>
                <v-col cols="2" style="text-align: left">
                  <b>Item {{ index + 1 }}</b>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="2" v-if="i.vendor_name != 'Not Available'">
                  <v-btn
                    color="primary"
                    small
                    style="text-align: right; display: inline"
                    @click="setTask(index)"
                    v-if="rolesTask.create_task"
                    >Create Task</v-btn
                  >
                </v-col>
              </v-row>

              <v-row class="border" v-if="i.isTask" style="margin-bottom: 5px">
                <v-col cols="7">
                  <!-- <v-text-field label="Note" v-model="i.dataTask.note" @change="showSaveBtn"></v-text-field> -->
                  <v-textarea
                    label="Note"
                    auto-grow
                    rows="1"
                    row-height="15"
                    v-model="i.dataTask.note"
                  ></v-textarea>
                </v-col>
                <v-col cols="4">
                  <v-select
                    :items="listDesigner"
                    :item-text="(obj) => obj.name"
                    :item-value="(obj) => obj.username"
                    label="Designer"
                    v-model="i.dataTask.designer_username"
                    @change="showSaveBtn"
                  ></v-select>
                </v-col>
                <v-col cols="1">
                  <br />
                  <!-- <v-btn color="green" small dark v-if="i.isTask == true" @click="saveTask(index)">Save</v-btn> -->
                  <v-btn
                    color="green"
                    small
                    dark
                    v-if="
                      i.dataTask.designer_username != '' &&
                      i.dataTask.note != ''
                    "
                    @click="
                      loader = 'loading';
                      saveTask(index);
                    "
                    :loading="loading"
                    :disabled="loading"
                  >
                    Save
                    <template v-slot:loader>
                      <span class="custom-loader">
                        <v-icon light>mdi-loading</v-icon>
                      </span>
                    </template>
                  </v-btn>
                  <v-btn color="green" small disabled v-else>Save</v-btn>
                  &nbsp;
                  <!-- <v-btn color="green" small dark @click="showIndex(index)">Save</v-btn> -->
                </v-col>
              </v-row>

              <div style="text-align: left">
                <b>Name: </b> {{ i.item_name }}
              </div>
              <div style="text-align: left"><b>SKU: </b> {{ i.sku }}</div>
              <div style="text-align: left">
                <b>Product Code:</b>{{ i.product_code }} - <b>Design URL:</b>
                <a
                  :href="i.design_url"
                  target="_blank"
                  rel="noopener noreferrer"
                  >Design URL</a
                >
                - <b>Quantity: </b> {{ i.quantity }} - <b>Vendor: </b>
                {{ i.vendor_name }} - <b>Template Size: </b>
                <template v-if="!i.err">{{ i.templateSize }}</template>
                <template v-else>
                  <v-chip class="ma-2" color="red" dark>
                    {{ i.templateSize }}
                  </v-chip>
                </template>
              </div>
              <v-row style="text-align: left">
                <v-col cols="6">
                  <b>Preview Image: </b>
                  <div><img :src="i.preview_link" style="width: 100%" /></div>
                </v-col>
                <v-col cols="6">
                  <b>Production Image: </b>{{ i.productSize }}
                  <div>
                    <img
                      :src="i.production_link"
                      style="width: 100%; background-color: grey"
                    />
                  </div>
                </v-col>
              </v-row>

              <div style="text-align: left" class="border">
                <v-col cols="12">
                  <b>Customer Choice:</b>
                  <v-row>
                    <v-col
                      cols="3"
                      v-for="(j, index) in i.customer_choice"
                      :key="index"
                      class="ma-0"
                    >
                      <b>{{ j.name }}</b
                      >:
                      <template v-if="j.value.includes('http')"
                        ><a
                          :href="j.value"
                          target="_blank"
                          rel="noopener noreferrer"
                          >Link</a
                        ></template
                      >
                      <template v-else>{{ j.value }}</template>
                    </v-col>
                  </v-row>
                </v-col>
              </div>
            </v-col>
          </div>
        </v-col>
      </v-col>
      <v-col cols="10" v-else>
        <img v-bind:src="require('../../assets/loading/loading.gif')" />
      </v-col>
    </v-row>
    <!-- </template> -->
  </div>
</template>

<script>
import Amplify, { Auth } from "aws-amplify";
import axios from "axios";
//import moment from 'moment'

Amplify.configure({
  Auth: {
    region: "ap-southeast-1",
    userPoolId: "ap-southeast-1_8vBdk5PAd",
    userPoolWebClientId: "51e572vhkn38k7tuvsdst697b1",
    mandatorySignIn: true,
  },
});

export default {
  name: "OrderPreview",

  data: () => ({
    loadingScreen: false,
    loader: null,
    loading: false,
    dataPreview: [],
    listDesigner: [],
    listOrderNumber: [],
    listVendor: [],
    selectedOrderData: {},
    selectedOrder: undefined,
    item: {},
    rolesTask: [],
    storeList: [],
    storeFilter: [],
    count: 0,
  }),

  watch: {
    selectedOrder() {
      //console.log("selectedOrder: ", this.selectedOrder);
      if (this.selectedOrder == undefined || this.selectedOrder == null) {
        this.selectedOrderData = {};
        this.item = {};
      }
    },
  },

  methods: {
    async loadData() {
      this.count = 0;
      var currentSession = await this.$root.$refs.App.currentSession(
        "order-preview-loadData"
      );
      //console.log('currentSession: ',currentSession.accessToken)
      if (currentSession.accessToken) {
        await axios
          .get(window.domain + "orders/review-customily-orders", {
            headers: { Authorization: currentSession.accessToken },
          })
          .then((response) => {
            console.log("order-preview loadData: ", response);
            // If request is good...
            this.listDesigner = response.data.data.designers;
            this.dataPreview = response.data.data.orders;
            this.listVendor = response.data.data.vendors;
            var tempStore = new Set();
            for (var i in this.dataPreview) {
              //var j = this.dataPreview[i].items.length
              var store = i;
              store = store.replace(/[^A-Za-z]+/g, "");
              tempStore.add(store);
              this.dataPreview[i]["orderNumItems"] =
                i + " (" + this.dataPreview[i].items.length + " item(s))";
              //console.log(this.dataPreview[i]["orderNumItems"])
              this.dataPreview[i]["selected"] = true;
              this.count += 1;
            }

            this.storeList = Array.from(tempStore);
            console.log("storeList: ", this.storeList);
            console.log("dataPreview: ", this.dataPreview);

            if (this.storeFilter.length > 0) {
              this.filterData();
            }
          })
          .catch((error) => {
            console.log("error " + error);
          });
      } else {
        console.log(
          "currentSession order-preview-loadData-undefined: ",
          currentSession
        );
      }
    },

    filterData() {
      this.count = 0;
      if (this.storeFilter.length > 0) {
        for (const k in this.dataPreview) {
          this.dataPreview[k]["selected"] = false;
        }

        for (const i of this.storeFilter) {
          console.log(i);
          for (const j in this.dataPreview) {
            if (j.indexOf(i) > -1) {
              this.dataPreview[j]["selected"] = true;
              this.count += 1;
            }
          }
        }
      } else {
        for (const k in this.dataPreview) {
          this.dataPreview[k]["selected"] = true;
          this.count += 1;
        }
      }
    },

    async chooseOrder(order_number) {
      this.loadingScreen = true;
      this.item = this.dataPreview[order_number];
      console.log(order_number);
      this.selectedOrderData = JSON.parse(JSON.stringify(this.item)); // Object.assign({}, this.item);
      console.log("selectedOrderData: ", this.selectedOrderData);
      await this.loadImgSize();
      this.loadingScreen = false;
    },

    addImageProcess(src) {
      return new Promise((resolve) => {
        let img = new Image();
        //console.log("img: ",img)
        img.onload = () => resolve(img.width + "x" + img.height);
        img.onerror = () => resolve("Error Size");
        img.src = src;
      });
    },

    async loadImgSize() {
      for (const i of this.selectedOrderData.items) {
        i["err"] = false;
        i["productSize"] = await this.addImageProcess(i.production_link);
        if (i.vendor_name == null) {
          i.vendor_name = "Not Available";
        }

        if (i.width != null && i.height != null)
          i["templateSize"] = i.width + "x" + i.height;
        else i["templateSize"] = "Not Available";

        if (i["productSize"] != i["templateSize"]) {
          if (!i["err"]) i["err"] = true;
        }
      }
    },

    async check() {
      this.selectedOrder = null;
    },

    setTask(index) {
      var temp = {};
      console.log(this.selectedOrderData.items[index]);
      if (
        this.selectedOrderData.items[index].isTask == false ||
        this.selectedOrderData.items[index].isTask == null
      ) {
        this.selectedOrderData.items[index].isTask = true;
        this.selectedOrderData.items[index]["dataTask"] = {
          item_id: this.selectedOrderData.items[index].item_id,
          item_index: this.selectedOrderData.items[index].item_index,
          item_name: this.selectedOrderData.items[index].item_name,
          order_number: this.selectedOrder,
          order_id: this.selectedOrderData.order_id,
          note: "",
          sku: this.selectedOrderData.items[index].sku,
          vendor_id: this.selectedOrderData.items[index].vendor_id,
          old_design_url: this.selectedOrderData.items[index].design_url,
          designer_username: "",
          assigner_username: "",
          product_code: this.selectedOrderData.items[index].product_code,
          customer_choice: this.selectedOrderData.items[index].customer_choice,
        };

        this.selectedOrderData.items.push(temp);
        this.selectedOrderData.items.splice(
          this.selectedOrderData.items.length - 1,
          1
        );
      } else {
        this.selectedOrderData.items[index].isTask = false;
        this.selectedOrderData.items[index].dataTask = {};

        this.selectedOrderData.items.push(temp);
        this.selectedOrderData.items.splice(
          this.selectedOrderData.items.length - 1,
          1
        );
      }
      //console.log(JSON.stringify(this.dataOrder.items[index]))
    },

    showSaveBtn() {
      var item = {};
      this.selectedOrderData.items.push(item);
      this.selectedOrderData.items.splice(
        this.selectedOrderData.items.length - 1,
        1
      );
    },

    async saveTask(index) {
      const l = this.loader;
      this[l] = !this[l];

      var currentSession = await this.$root.$refs.App.currentSession(
        "order-edit-saveTask"
      );

      if (currentSession.accessToken) {
        this.selectedOrderData.items[index].dataTask.assigner_username =
          currentSession.username;
        console.log("data: ", this.selectedOrderData.items[index].dataTask);
        await fetch(window.domain + "tasks", {
          method: "POST",
          headers: { Authorization: currentSession.accessToken },
          body: JSON.stringify(this.selectedOrderData.items[index].dataTask),
        })
          .then((response) => response.json())
          .then(async (data) => {
            console.log("order-preview saveTask response: ", data);
            await this.loadData();
            this.selectedOrder = this.selectedOrderData.next_item;
            this.selectedOrderData = {};
            var tempSelected;
            if (this.selectedOrder != null) {
              if (this.storeFilter.length > 0) {
                for (const i of this.storeFilter) {
                  console.log(i);
                  if (this.selectedOrder.indexOf(i) > -1) {
                    tempSelected = true;
                    await this.chooseOrder(this.selectedOrder);
                    break;
                  } else {
                    tempSelected = false;
                    this.selectedOrderData = {};
                  }
                }
                if (!tempSelected) {
                  this.selectedOrder = undefined;
                }
              } else {
                await this.chooseOrder(this.selectedOrder);
              }
            } else {
              this.selectedOrderData = {};
            }
            console.log("selectedOrder: ", this.selectedOrder);
            console.log("selectedOrderData: ", this.selectedOrderData);
          })
          .catch((error) => console.log("Error: ", error));
      } else {
        console.log(
          "currentSession order-edit-saveTask-undefined: ",
          currentSession
        );
      }

      this[l] = false;
      this.loader = null;
    },
  },

  async mounted() {
    this.rolesTask = await this.$cookies.get("task");
    try {
      await Auth.currentAuthenticatedUser({ bypassCache: false });
    } catch {
      console.log("User logged out!");
      this.$router.push("/login");
    }

    this.loadData();
  },
};
</script>

<style scoped>
.ordernum-scroll {
  height: 70vh;
  overflow: auto;
}
</style>